import _ from 'lodash';

import {DataGroupModel} from '../../models/api/dataGroupModel';
import {ResourceMap} from '../appTypes';
import {DataState} from './dataState';

/*
 * Types.
 */

export interface DataCascade {
  prevData?: DataState;
  data: DataState;
  // TODO: Deprecate this and let reducers calculate this themselves as-needed.
  updatedResources: Pick<
    DataGroupModel,
    'conversations' | 'messages' | 'activities' | 'calendarEventVersions'
  >;
}

/*
 * Helpers.
 */

export function createDataCascade(prevData: DataState | undefined, nextData: DataState): DataCascade {
  // For legacy reasons, we don't need to send updatedResources for the initial data state.
  if (!prevData) {
    return {
      data: nextData,
      updatedResources: {},
    };
  }

  const updatedResources = {
    conversations: selectUpdatedResources(prevData.conversations.byId, nextData.conversations.byId),
    messages: selectUpdatedResources(prevData.messages, nextData.messages),
    activities: selectUpdatedResources(prevData.activities, nextData.activities),
    calendarEventVersions: selectUpdatedResources(
      prevData.calendarEventVersions,
      nextData.calendarEventVersions,
    ),
  };

  return {
    prevData,
    data: nextData,
    updatedResources,
  };
}

function selectUpdatedResources<T>(prevResources: ResourceMap<T>, nextResources: ResourceMap<T>) {
  if (prevResources === nextResources) {
    return [];
  }

  return _(nextResources)
    .keys()
    .filter((key) => prevResources[key] !== nextResources[key])
    .map((key) => nextResources[key])
    .compact()
    .value();
}
